module.exports = __webpack_public_path__ + "static/media/demo.3d61e50c.jpg";